import { Avatar, Tooltip, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IProfessionalPictureProps {
  imageUrl: string;
  name: string;
  size?: number;
}

// Map the legacy px size to the nearest DS Avatar preset.
const toAvatarSize = (px: number): 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' => {
  if (px <= 24) return 'xs';
  if (px <= 32) return 'sm';
  if (px <= 40) return 'md';
  if (px <= 48) return 'lg';
  if (px <= 64) return 'xl';
  return '2xl';
};

export const ProfessionalPicture = ({ imageUrl, name, size = 48 }: IProfessionalPictureProps) => {
  return (
    <Tooltip
      content={
        <Typography as="span" bold color={colors.shades[0]}>
          {name}
        </Typography>
      }
      placement="bottom"
    >
      {/* DS Avatar handles the circle, sizing, and the missing/broken-image fallback (GOTU-4428). */}
      <Avatar src={imageUrl || undefined} size={toAvatarSize(size)} alt={name} />
    </Tooltip>
  );
};
